async function waitForValue(value: any, expected: any, timeout = 5000): Promise<any> {
    // console.log(`${new Date().toISOString()} called waitForValue: ${value}`);
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            if (value === expected) {
                clearInterval(interval);
                // console.log(`${new Date().toISOString()} returning waitForValue: ${value}`);
                resolve(value);
            } else {
                // console.log(`${new Date().toISOString()} waiting waitForValue: ${value}`);
            }
        }, 250);

        setTimeout(() => {
            clearInterval(interval);
            // console.log(`${new Date().toISOString()} waiting waitForValue: ${value}`);
            // reject("Timed out");
            resolve(value);
        }, timeout);
    });
}

export { waitForValue };
